import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-popup-section-paginas-confirm',
    templateUrl: './popup-section-paginas-confirm.component.html',
    styleUrls: ['./popup-section-paginas-confirm.component.scss'],
})
export class PopupSectionPaginasConfirmComponent {
    constructor(
        public dialogRef: MatDialogRef<PopupSectionPaginasConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public parametros: any
    ) {}

    cerrarPopup(param: boolean) {
        this.dialogRef.close(param);
    }
}
